import { Injectable } from '@angular/core';
import {
  ColumnWithTranslation,
  Translation,
} from '@maximizer/core/shared/domain';
import { Observable, map, of } from 'rxjs';
const defaultColumns: Observable<ColumnWithTranslation[]> = of([
  {
    id: 'groupField',
    field: '{{groupField}}',
    title: {
      translationID: '',
      resourceID: '',
    } as Translation,
    locked: false,
    sticky: false,
    hidden: true,
    groupable: true,
  },
  {
    id: 'c0',
    field: '{{type}}',
    title: {
      translationID: 'timeline.columns.type',
      resourceID: 'JSS_GenTxtType',
    } as Translation,
    locked: false,
    sticky: false,
    hidden: false,
    groupable: false,
  },
  {
    id: 'c1',
    field: '{{startDate}}',
    title: {
      translationID: 'timeline.columns.datetime',
      resourceID: 'JSS_GenTxtDateTimeLabel',
    } as Translation,
    locked: false,
    sticky: false,
    hidden: false,
    groupable: false,
  },
  {
    id: 'c2',
    field: '{{subject}}',
    title: {
      translationID: 'timeline.columns.subject',
      resourceID: 'JSS_GenTxtSubject',
    } as Translation,
    locked: false,
    sticky: false,
    hidden: false,
    clickable: true,
    groupable: false,
  },
  {
    id: 'c3',
    field: '{{description}}',
    title: {
      translationID: 'timeline.columns.description',
      resourceID: 'JSS_GenTxtDescription',
    } as Translation,
    locked: false,
    sticky: false,
    hidden: false,
    clickable: false,
    groupable: false,
  },
  {
    id: 'c4',
    field:
      '{%IF {{abEntries}} != NULL %} {{abEntries}} {%ELSEIF {{leads}} != NULL %} {{leads}} {%ENDIF%}',
    title: {
      translationID: 'timeline.columns.with',
      resourceID: 'JSS_GenTxtName',
    } as Translation,
    locked: false,
    sticky: false,
    hidden: false,
    clickable: true,
    groupable: false,
  },
  {
    id: 'c5',
    field: '{{with}}',
    title: {
      translationID: 'timeline.columns.regarding',
      resourceID: 'JSS_GenTxtRegarding',
    } as Translation,
    locked: false,
    sticky: false,
    hidden: false,
    clickable: true,
    groupable: false,
  },
  {
    id: 'c6',
    field: '{{users}}',
    title: {
      translationID: 'timeline.columns.user',
      resourceID: 'JSS_GenTxtUser',
    } as Translation,
    locked: false,
    sticky: false,
    hidden: false,
    groupable: false,
  },
  {
    id: 'c7',
    field: '{{interactionCategory}}',
    title: {
      translationID: 'timeline.columns.category',
      resourceID: 'JSS_GenTxtCategory',
    } as Translation,
    locked: false,
    sticky: false,
    hidden: false,
    groupable: false,
  },
]);
@Injectable()
export class ColumnsService {
  readColumns(): Observable<ColumnWithTranslation[]> {
    return defaultColumns.pipe(
      map((column) => {
        return column;
      }),
    );
  }
}
